module.exports = require('./readable').Transform



// WEBPACK FOOTER //
// ./~/readable-stream/transform.js